import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
@Injectable({
  providedIn: "root"
})
export class HollywoodServiceService {  
  constructor(
    private http: HttpClient
  ) {

  }
  basepath = "https://hollywoodhighlights.com/";
  sitename = "Hollywood Highlights";
  serviceurl = this.basepath + "testunl/";
  viewurl = this.basepath + "testunl/views/";
  nodeurl = this.basepath + "testunl/node/";
  cTermId = 0;
  nodeuploadurl = this.basepath + "testunl/node.json";
  addDomainName = "hollywoodhighlights.com";
  image_preset = "&img_preset=service_mobile1";
  img_preset="service_mobile1";
  desc_Page =``
    ".json?img_preset=desc_tab";
  cat_Videos = "&img_preset=service_mobile1&args[0]=290";
  desc_Videos =
    this.viewurl +
    "unl_service_content_videos.json?img_preset=service_mobile1&args=";
  vidCatagories = this.viewurl + "unl_service_allterms.json?args=3&limit=50&display_id=block_3";
  phtoCatagories = this.viewurl + "unl_service_allterms.json?args=14&limit=50&display_id=block_4";
  vid_recent =
    this.viewurl +
    "unl_service_recent_mostv_videos.json?display_id=page_5" +
    this.cat_Videos;
  vid_most =
    this.viewurl +
    "unl_service_recent_mostv_videos.json?display_id=page_6" +
    this.cat_Videos;
  parentwidth;
  vid_Catagories = [
    {
      name: "vid_recent",
      url:
        this.viewurl +
        "unl_service_recent_mostv_videos.json?display_id=page_5" +
        this.cat_Videos
    },
    {
      name: "vid_most",
      url:
        this.viewurl +
        "unl_service_recent_mostv_videos.json?display_id=page_6" +
        this.cat_Videos
    }
  ];
  phto_Catagories = [
    {
      name: "phto_recent",
      url:
        this.viewurl +
        "unl_service_recent_mostv_photos.json?display_id=page_5" +
        this.cat_Videos
    },
    {
      name: "phto_most",
      url:
        this.viewurl +
        "unl_service_recent_mostv_photos.json?display_id=page_6" +
        this.cat_Videos
    }
  ];
  moreDetailsArray;
  menus = [
    {
      title: "ALL",
      metatitle: "Movies - New Movie Releases & showtimes, Movie Trailers, Downloads, Reviews and Hollywood News | Hollywood Highlights",
      metadescription:"Worldwide source for new movie releases, premieres & showtimes. Check out the newest movie trailers and hollywood news & find out about upcoming parties, casting calls or special events",
      metakeywords: "movies, new movie releases, movie news, movie trailers, movie showtimes, movie reviews, movie downloads, movie premieres, casting calls, parties, hollywood news",
      metaabstract: "Hollywood Highlights is the worldwide source for new movie releases, premieres, movie news, hollywood news & showtimes",
      type: 1,
      ctype: "all",
      tabs: [
        {
          title: "Trending News",
          url: this.basepath + "unlservice_todaysnews.php?cit="
        }
      ],
      msg: "No Treding news to display",
      linktext: "Add your Trending News here",
      popuptext:
        "Adding Trending news feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-home",
      link: "all"
    },
    {
      title: "NIGHTCLUBS",
      metatitle: "Nightclubs | Nightlife.net",
      metadescription:"Nightlife.net is the worldwide source for nightclubs, bars, restaurants, parties, & events",
      metakeywords: "nightclubs, nightlife, night clubs, dance clubs, entertainment",
      metaabstract: "Nightlife.net is your source for nightlife, nightclubs, restaurants, celebrities, dance clubs, guest lists, music, movies, fashion, and entertainment news in all major cities.",
      type: 1,
      ctype: "nightclubs",
      morecontent: true,
      msg: "No Nightclubs to display",
      linktext: "Add your Nightclubs here",
      popuptext:
        "Adding Nightclubs feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "far fa-moon",
      link: "nightclubs",
      tabs: [
        {
          title: "Featured Nightclubs",
          url:
            this.viewurl +
            "unl_service_featured_block.json/?limit=10&display_id=block_5",
          viewall:
            this.viewurl +
            "unl_service_nightclubs_tabs.json/?limit=10&display_id=block_1&page=0"
        },
        {
          title: "Nightclub News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1675"
        },
        {
          title: "Recently Added Nightclubs",
          url:
            this.viewurl +
            "unl_service_nightclubs_tabs.json/?limit=10&display_id=block_2"
        }, 
        {
          title: "More Nightclubs",
          url:
            this.viewurl +
            "unl_service_nightclubs_tabs.json?limit=3&display_id=block_1"
        },
      ]
    },
    {
      title: "BARS",
      metatitle: "Bars | Nightlife.net",
      metadescription:"Nightlife.net is the worldwide source for bars, nightclubs, restaurants, parties, & events",
      metakeywords: "bars, nightlife, entertainment",
      metaabstract: "Nightlife.net is the worldwide source for bars, bar news & events",
      type: 1,
      ctype: "bars",
      morecontent: true,
      msg: "No bars to display",
      linktext: "Add your Bars here",
      popuptext:
        "Adding bars feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fa fa-beer",
      link: "bars",
      tabs: [
        {
          title: "Featured Bars",
          url:
            this.viewurl +
            "unl_service_featured_block.json?limit=10&display_id=block_1",
          viewall:
            this.viewurl +
            "unl_service_bars_module_tabs.json/?limit=10&display_id=block_1&page=0"
        },
        {
          title: "Bar News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1676"
        },
        {
          title: "Recently Added Bars",
          url:
            this.viewurl +
            "unl_service_bars_module_tabs.json?limit=10&display_id=block_2"
        },
        {
          title: "More Bars",
          url:
            this.viewurl +
            "unl_service_bars_module_tabs.json?limit=10&display_id=block_1"
        }
      ]
    },
    {
      title: "RESTAURANTS",
      metatitle: "Restaurants  - See the Best Restaurants | Nightlife.net",
      metadescription:"Nightlife.net is the worldwide source for restaurants, dining, reservations and entertainment",
      metakeywords: "restaurants, steakhouse, pizza, Italian restaurants, Chinese restaurants, Mexican restaurants, dinner reservations, restaurant reservations, fine dining, casual dining",
      metaabstract: "Nightlife.net is the worldwide source for restaurants, dining, reservations and entertainment",
      type: 1,
      ctype: "restaurants",
      morecontent: true,
      msg: "No restaurants to display",
      linktext: "Add your Restaurants here",
      popuptext:
        "Adding Restaurants feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-utensils",
      link: "restaurants",
      tabs: [
        {
          title: "Featured Restaurants",
          url:
            this.viewurl +
            "unl_service_featured_block.json?limit=10&display_id=block_3",
          viewall:
            this.viewurl +
            "unl_service_restaurants_tabs.json/?limit=10&display_id=block_1&page=0"
        },
        {
          title: "Restaurant News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1678"
        },
        {
          title: "Recently Added Restaurants",
          url:
            this.viewurl +
            "unl_service_restaurants_tabs.json/?limit=10&display_id=block_2"
        },
        {
          title: "More Restaurants",
          url:
            this.viewurl +
            "unl_service_restaurants_tabs.json?limit=10&display_id=block_1"
        }
      ]
    },
    {
      title: "CONCERTS & SHOWS",
      metatitle:  "Concerts & Shows - Concert Tickets, Theatre Tickets, Sports Tickets | Nightlife.net",
      metadescription:"Nightlife.net the worldwide source for concert, theater, and special event tickets",
      metakeywords: "concerts, shows, theater, concert tickets, theater tickets, broadway shows, entertainment",
      metaabstract: "Nightlife.net is the worldwide for source for concerts, shows & tickets",
      type: 1,
      ctype: "concerts",
      morecontent: true,
      tabs: [
        {
          title: "Featured Concerts & Shows",
          url:
            this.viewurl +
            "unl_service_featured_block.json?limit=10&display_id=block_6",
          viewall:
            this.viewurl +
            "unl_service_concerts_module_tabs.json/?limit=10&display_id=block_1&page=0"
        },
        // {
        //   title: "Upcoming Concerts & Shows",
        //   url:
        //     this.viewurl +
        //     "unl_service_concerts_module_tabs.json?limit=10&display_id=block_1"
        // },
        {
          title: "Concert News",
          url:
            this.viewurl +
            "unl_service_news_page.json?limit=10&display_id=page_2&args[0]=1677"
        },
        {
          title: "Recently Added Concerts",
          url:
            this.viewurl +
            "unl_service_concerts_module_tabs.json/?limit=10&display_id=block_2"
        },
        {
          title: "More Concerts",
          url:
            this.viewurl +
            "unl_service_concerts_module_tabs.json/?limit=3&display_id=block_1"
        }
      ],
      msg: "No concerts & shows to display",
      linktext: "Add your Concerts & Shows here",
      popuptext:
        "Adding concerts & shows feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-ticket-alt",
      link: "concerts"
    },
    {
      title: "PARTIES & EVENTS",
      metatitle: "Parties & Events - Celebrity Events, Nightclub Events, Bar Events, Restaurant Events, Movie Events, Music Events, Fashion Events, Charity Events | NightLife.net",
      metadescription:"Nightlife.net is the worldwide source for nightlife events, parties, concerts, nightclubs, bars, restaurants, shows, & entertainment news",
      metakeywords: "celebrity events, nightclub events, bar events, restaurant events, movie events, music events, fashion events, charity events, concerts, parties, fashion shows, fundraisers, casting calls",
      metaabstract: "Nightlife.net is your source for nightlife, nightclubs, restaurants, celebrities, dance clubs, guest lists, music, movies, fashion, and entertainment news in all major cities.",
      type: 1,
      ctype: "events",
      morecontent: true,
      tabs: [
        {
          title: "Featured Events",
          url:
            this.viewurl +
            "unl_service_featured_block.json?limit=10&display_id=block_2",
          viewall:
            this.viewurl +
            "unl_service_events_module_tabs.json?display_id=block_1&page=0"
        },
        // {
        //   title: "Upcoming Parties & Events",
        //   url:
        //     this.viewurl +
        //     "unl_service_events_module_tabs.json?limit=10&display_id=block_1"
        // },
        {
          title: "Event News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1671"
        },
        {
          title: "Recently Added Events",
          url:
            this.viewurl +
            "unl_service_events_module_tabs.json/?limit=10&display_id=block_3"
        },
        {
          title: "More Events",
          url:
            this.viewurl +
            "unl_service_events_module_tabs.json/?limit=3&display_id=block_1"
        }
      ],
      msg: "No parties & events to display",
      linktext: "Add your Parties & Events here",
      popuptext:
        "Adding parties & events feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-glass-martini",
      link: "event"
    },
    {
      title: "HOTELS & RESORTS",
      metatitle: "Hotels & Resorts | Nightlife.net",
      metadescription:"Looking for hotels & resorts? Check out the number one source for all your worldwide hotel needs & desires",
      metakeywords: "hotels, resorts, hotel reservations, travel reservations, vacation packages, travel packages",
      metaabstract: "Nightlife.net is the worldwide source for hotels, resorts & nightlife",
      type: 1,
      ctype: "hotel",
      morecontent: true,
      msg: "No hotels & resorts to display",
      linktext: "Add your Hotels & Resorts here",
      popuptext:
        "Adding hotels & resorts feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-hotel",
      link: "hotel",
      tabs: [
        {
          title: "Featured Hotels & Resorts",
          url:
            this.viewurl +
            "unl_service_featured_block.json?limit=10&display_id=block_4",
          viewall:
            this.viewurl +
            "unl_service_hotels_module_tabs.json/?limit=10&display_id=block_1&page=0"
        },
        // {
        //   title: "HOTELS & RESORTS",
        //   url:
        //     this.viewurl +
        //     "unl_service_hotels_module_tabs.json?limit=10&display_id=block_1"
        // },
        {
          title: "Hotel News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1679"
        },
        {
          title: "Recently Added hotels",
          url:
            this.viewurl +
            "unl_service_hotels_module_tabs.json/?limit=10&display_id=block_2"
        },
        {
          title: "More Hotels",
          url:
            this.viewurl +
            "unl_service_hotels_module_tabs.json/?limit=3&display_id=block_2"
        }
      ]
    },
    {
      title: "TRANSPORTATION",
      metatitle: "Travel & Transportation - Limousines, Cars, Private Jets, Taxi, Car Rental | Nightlife.net",
      metadescription:"Looking for transportation?? Check out the number one source for all your worldwide transportation needs & desires",
      metakeywords: "transportation, travel, private jets, limousines, car rental, car service, taxi, uber, lyft",
      metaabstract: "Nightlife.net is the worldwide source for private jets, limousines, car rental & car service transportation",
      type: 1,
      ctype: "transportation",
      morecontent: true,
      msg: "No transportation to display",
      linktext: "Add your Transportation here",
      popuptext:
        "Adding transportation feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-truck fa-flip-horizontal",
      link: "transportation",
      tabs: [
        {
          title: "Featured Transportation",
          url:
            this.viewurl +
            "unl_service_featured_block.json?limit=10&display_id=block_7",
          viewall:
            this.viewurl +
            "unl_service_transportation_tabs.json/?limit=10&display_id=block_1&page=0"
        },
        {
          title: "Transportation News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1680"
        },
        {
          title: "Recently Added",
          url:
            this.viewurl +
            "unl_service_transportation_tabs.json/?limit=10&display_id=block_2"
        },
        {
          title: "More Transportation",
          url:
            this.viewurl +
            "unl_service_transportation_tabs.json?limit=10&display_id=block_1"
        }
      ]
    },
    {
      title: "VIDEOS",
      metatitle: "Videos: Movies, Actors, Celebrity Videos, News Videos and more | Hollywood Highlights",
      metadescription: "Worldwide source for new movies, trailers, premieres & showtimes. Check out the latest hollywood news & find out about upcoming parties, casting calls or special events",
      metakeywords: "hollywood, news, movies, new movie releases, movie trailers, movie showtimes, movie news, movie reviews, movie premieres, casting calls, entertainment news",
      metaabstract: "Hollywood Highlights is the worldwide source for new movie releases, premieres, movie news, hollywood news & showtimes",
      type: 2,
      ctype: "video1",
      morecontent: true,
      msg: "No videos to display",
      linktext: "Add your Videos here",
      popuptext:
        "Adding videos feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-video",
      link: "videos",
      tabs: [
        {
          title: "Recent",
          url:
            this.viewurl +
            "unl_service_recent_mostv_videos.json?display_id=page_5&args[0]=all&img_preset=service_mobile1"
        },
        {
          title: "Most Viewed",
          url:
            this.viewurl +
            "unl_service_recent_mostv_videos.json?display_id=page_6&args[0]=all&img_preset=service_mobile1"
        },
        {
          title: "More Videos",
          isinindex:false,
          url:
            this.viewurl +
            "unl_service_recent_mostv_videos.json?limit=3&display_id=page_5&args[0]=all&img_preset=service_mobile1"
        },
      ]
    },
    {
      title: "PHOTOS",
      metatitle: "Hollywood Photos | Hollywood Highlights",
      metadescription:"Hollywood Photos - movies, people, places, actors, actresses & more",
      metakeywords: "hollywood, photos, celebrity photos, party photos, fashion photos",
      metaabstract: "Hollywood Highlights is the worldwide source for new movie releases, premieres, movie news, hollywood news & showtimes",
      type: 3,
      ctype: "photos",
      morecontent: true,
      msg: "No photos to display",
      linktext: "Add your Photos here",
      popuptext:
        "Adding photos feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-camera",
      link: "photos",
      tabs: [
        {
          title: "Recent",
          url:
            this.viewurl +
            "unl_service_recent_mostv_photos.json?display_id=page_5&img_preset=service_mobile1&args[0]=290"
        },
        {
          title: "Most Viewed",
          url:
            this.viewurl +
            "unl_service_recent_mostv_photos.json?display_id=page_6&img_preset=service_mobile1&args[0]=290"
        },
        {
          title: "More Photos",
          isinindex:false,
          url:
            this.viewurl +
            "unl_service_recent_mostv_photos.json?limit=3&display_id=page_5&img_preset=service_mobile1&aargs[0]=290"
        },
      ]
    },
    {
      title: "MUSIC",
      metatitle: "Music News: New Music Releases, Music Videos, Music Downloads, DJ's & Album Reviews | NightLife.net",
      metadescription:"Nightlife.net is the worldwide source for music news & new music releases. Check out new music videos, downloads, DJ mixes and reviews, plus find out about upcoming parties and special events",
      metakeywords: "music news, music events, new music releases, music videos, new music downloads, album release parties, new cd releases, DJ's, DJ mixes",
      metaabstract: "Nightlife.net is your source for nightlife, nightclubs, restaurants, celebrities, dance clubs, guest lists, music, movies, fashion and entertainment news in all major cities.",
      type: 1,
      ctype: "music",
      morecontent: true,
      msg: "No music to display",
      linktext: "Add your Musics here",
      popuptext:
        "Adding musics feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-headphones",
      link: "music",
      tabs: [
        {
          title: "MUSIC NEWS",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1672",
          viewall:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1672"
        },
        {
          title: "New Music Releases",
          url:
            this.viewurl +
            "unl_service_music_index_block.json?limit=10&args=all&display_id=block_1"
        },
        {
          title: "Music videos",
          url:
            this.viewurl +
            "unl_service_music_videos.json?limit=10&display_id=block_1",
          type: 2
        },
        {
          title: "More Music Releases",
          url:
            this.viewurl +
            "unl_service_music_index_block.json?limit=3&args=all&display_id=block_1"
        }
      ]
    },
    {
      title: "MOVIES",
      metatitle: "Movies - New Movie Releases & showtimes, Movie Trailers, Downloads, Reviews and Hollywood News | Hollywood Highlights",
      metadescription:"Worldwide source for new movie releases, premieres & showtimes. Check out the newest movie trailers and hollywood news & find out about upcoming parties, casting calls or special events",
      metakeywords: "hollywood highlights, movies, new movie releases, movie news, movie trailers, movie showtimes, movie reviews, movie downloads, movie premieres, casting calls, parties, hollywood news",
      metaabstract: "Hollywood Highlights is the worldwide source for new movie releases, premieres, movie news, hollywood news & showtimes",
      type: 1,
      ctype: "movies",
      morecontent: true,
      msg: "No movies to display",
      linktext: "Add your Movies here",
      popuptext:
        "Adding movies feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-film",
      link: "movies",
      tabs: [
        {
          title: "Trending News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1673",
          viewall:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1673"
        },
        {
          title: "Coming Soon - Movies",
          url:
            this.viewurl +
            "unl_service_movies_module_tabs.json?limit=10&display_id=block_2"
        },
        {
          title: "Now Playing",
          url:
            this.viewurl +
            "unl_service_movies_module_tabs.json?limit=10&display_id=block_1"
        },
        {
          title: "New On DVD/BLU-RAY",
          url:
            this.viewurl +
            "unl_service_movies_module_tabs.json?limit=10&display_id=block_3"
        },
        {
          title: "Movie Trailer & Previews",
          url:
            this.viewurl +
            "unl_service_movie_videos.json?limit=10&display_id=block_1",
          type: 2
        },
        {
          title: "More Movies",
          url:
            this.viewurl +
            "unl_service_movies_module_tabs.json?limit=10&display_id=block_2"
        }
      ]
    },
    {
      title: "FASHION NEWS",
      metatitle: "Fashion News - Fashion Shows, Fashion Designers, Fashion Parties & Fashion Events | Nightlife.net",
      metadescription:"Worldwide source for fashion news, shows, designers, parties and special events",
      metakeywords: "nightlife, fashion news, fashion shows, fashion events, fashion premieres, fashion designers, fashion parties, shopping",
      metaabstract: "Nightlife.net is a worldwide source for fashion news, fashion shows, fashion events, fashion premieres, fashion designers, fashion parties & shopping.",
      type: 1,
      ctype: "fashion_store",
      morecontent: true,
      msg: "No fashion news to display",
      linktext: "Add your Fashion News here",
      popuptext:
        "Adding fashion news feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "fas fa-female",
      link: "fashion",
      tabs: [
        {
          title: "Trending News",
          url:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1674",
          viewall:
            this.viewurl +
            "unl_service_news_page.json/?limit=10&display_id=page_2&args[0]=1674"
        },
        {
          title: "Upcoming Fashion Events",
          url:
            this.viewurl +
            "unl_service_fashion_module_tabs.json?display_id=block_1"
        },
        {
          title: "Fashion Videos & Previews",
          url:
            this.viewurl +
            "unl_service_fashion_videos.json?limit=10&display_id=block_1",
          type: 2
        },
        {
          title: "Fashion Stores & Boutiques",
          url:
            this.viewurl +
            "unl_service_fashion_module_tabs.json?display_id=page_1"
        },
        {
          title: "More Fashion Videos & Previews",
          url:
            this.viewurl +
            "unl_service_fashion_videos.json?limit=10&display_id=block_1",
          type: 2
        },
        {
          title: "More Fashion Stores & Boutiques",
          url:
            this.viewurl +
            "unl_service_fashion_module_tabs.json?display_id=page_1"
        },
        {
          title: "More Upcoming Fashion Events",
          url:
            this.viewurl +
            "unl_service_fashion_module_tabs.json?display_id=block_1"
        },
      ]
    },
    {
      title: "NEWS",
      metatitle: "News | Hollywood Highlights",
      metadescription:"Hollywood Highlights is the worldwide source for nightlife news, shows, nightclubs, bars, restaurants, parties, concerts & events",
      metakeywords: "news, nightlife news, nightclub news, restaurant news, fashion news, travel news, music news, movie news, hotel news, transportation news, resort news",
      metaabstract: "Hollywood Highlights is the worldwide source for nightlife, nightclubs, restaurants, celebrities, dance clubs, guest lists, music, movies, fashion and entertainment news in all major cities.",
      type: 1,
      ctype: "news",
      morecontent: true,
      msg: "No news to display",
      linktext: "Add your News here",
      popuptext:
        "Adding news feature is not currently available via mobile app, Please logon to " +
        this.addDomainName +
        " via desktop to add your listing",
      icon: "far fa-newspaper",
      link: "news",
      tabs: [
        {
          title: "NEWS",
          url:
            this.viewurl +
            "unl_service_news_page.json?limit=10&display_id=page_2&args[0]=1673"
        },
        {
          title: "More News",
          url:
            this.viewurl +
            "unl_service_news_page.json?limit=10&display_id=page_2&args[0]=1673"
        }
      ]
    }
  ];
  vpd: any;

  setTermId(id: any) {
    this.cTermId = id;
  }
  getTermId() {
    return this.cTermId;
  }
  getcMenu(cIndex: number) {
    return this.menus[cIndex];
  }
  getIndexBycType(ct: string) {
    if (ct === "all") {
      return 0;
    } else if (ct === undefined) {
      return 0;
    } else {
      var cIndex = 0;
      try {
        if (ct.length === 0) {
          cIndex = 0;
        } else {
          for (let i = 0; i < this.menus.length; i++) {
            var c = this.menus[i].link;
            if (c === ct) {
              cIndex = i;
              break;
            }
          }
        }
      } catch (e) {
        cIndex = 0;
      }

      return cIndex;
    }

  }

  getMenuIndexByTitle(title) {
    var index = 0;
    for (var i in this.menus) {
      if (
        this.menus[i].title
          .toUpperCase()
          .trim()
          .replace(/\s/g, "") ===
        title
          .toUpperCase()
          .trim()
          .replace(/\s/g, "")
      ) {
        index = parseInt(i);
        break;
      }
    }
    return index;
  }
  indexL = [];
  setMenuIndex() {
    for (var i in this.all_tab_order) {
      this.indexL.push(this.getMenuIndexByTitle(
        this.all_tab_order[i].title
      ));
    }

  }
  all_tab_order = [
    {
      title: "Parties & events",
      type: 1,
      index: 0
    },
    {
      title: "Concerts & Shows",
      type: 1,
      index: 0
    },
    {
      title: "restaurants",
      type: 1,
      index: 0
    },
    {
      title: "night clubs",
      type: 1,
      index: 0
    },
    {
      title: "bars",
      type: 1,
      index: 0
    },
    {
      title: "hotels & resorts",
      type: 1,
      index: 0
    },
    {
      title: "transportation",
      type: 1,
      index: 0
    },
    {
      title: "Videos",
      type: 2,
      index: 0
    },
    {
      title: "photos",
      type: 3,
      index: 0
    },
    {
      title: "music",
      type: 1,
      index: 0
    },
    {
      title: "movies",
      type: 1,
      index: 0
    },
    {
      title: "fashion news",
      type: 1,
      index: 0
    },
    {
      title: "news",
      type: 1,
      index: 0
    }
  ];
  typeDetailsLabel = {
    nightclubs: {
      lbl: "Nightclub Type",
      vid: 7
    },
    bars: {
      lbl: "Bar Type",
      vid: 9
    },
    restaurants: {
      lbl: "Restaurant Type",
      vid: 10
    },
    concerts: {
      lbl: "Type",
      vid: 8
    },
    event: {
      lbl: "Type of Event",
      vid: 6
    },
    hotel: {
      lbl: "Type of Event",
      vid: 16
    },
    transportation: {
      lbl: "Type of Event",
      vid: 11
    }
  };
  locationDetailsLabel = {
    event: [
      {
        key: "field_event_time",
        lbl: "Date"
      },
      {
        key: ["field_event_fromtime", "field_event_totime", "field_event_timezone_cust"],
        lbl: "Time",
        concat: "to"
      },
      {
        key: "field_mevent_musicstyle",
        lbl: "Music Style"
      },
      {
        key: "field_mevent_agereq",
        lbl: "Age Requirements"
      },
      {
        key: "field_mevent_dresscode",
        lbl: "Dress Code"
      },
      {
        key: "field_mevent_prices",
        lbl: "Prices"
      },
      {
        key: "field_mevent_parkingoptions",
        lbl: "Parking Options"
      },
      {
        key: "field_mevent_drinkspecials",
        lbl: "Specials"
      }
    ],
    music: [
      {
        key: "field_music_release_date",
        lbl: "Date"
      },
      {
        key: "field_music_record_label",
        lbl: "Record Label"
      },
      {
        key: "field_music_lang",
        lbl: "Language"
      }
    ],
    concerts: [
      {
        key: "field_concerts_time",
        lbl: "Date"
      },
      {
        key: ["field_concert_fromtime", "field_concert_totime", "field_concerts_timezone_cust"],
        lbl: "Time",
        concat: "to"
      },
      {
        key: "field_concerts_agereq",
        lbl: "Age Requirements"
      },
      {
        key: "field_concerts_dresscode",
        lbl: "Dress Code"
      },
      {
        key: "field_concerts_prices",
        lbl: "Prices"
      },
      {
        key: "field_concert_parking",
        lbl: "Parking Options"
      }
    ],
    bars: [
      {
        key: "field_bars_timings",
        lbl: "Hours"
      },
      {
        key: "field_bars_music",
        lbl: "Music"
      },
      {
        key: "field_bars_dress_code",
        lbl: "Dress Code"
      },
      {
        key: "field_bars_price",
        lbl: "Price"
      },
      {
        key: "field_bars_specials",
        lbl: "Specials & Promotions"
      },
      {
        key: "field_bars_age",
        lbl: "Age Requirements"
      }
    ],
    fashion_store: [
      {
        key: "field_store_hours",
        lbl: "Store Hours"
      },
      {
        key: "field_store_specials",
        lbl: "Special & Promotions"
      }
    ],
    hotel: [
      {
        key: "field_hot_specials",
        lbl: "Specials & Promotions"
      },
      {
        key: "field_hotel_payment",
        lbl: "Payment Options"
      }
    ],
    movies: [
      {
        key: "field_rel_date",
        lbl: "Release Date",
        date: true
      },
      {
        key: "field_movie_rated",
        lbl: "Rated"
      },
      {
        key: "field_runtime",
        lbl: "Runtime"
      },
      {
        key: "field_genres",
        lbl: "Genres"
      },
      {
        key: "field_director",
        lbl: "Director"
      },
      {
        key: "field_starring",
        lbl: "Cast"
      },
      {
        key: "field_producers",
        lbl: "Producers"
      },
      {
        key: "field_writers",
        lbl: "Writers"
      },
      {
        key: "field_language",
        lbl: "Language"
      }
    ],
    nightclubs: [
      {
        key: "field_nightclub_timings",
        lbl: "Hours"
      },
      {
        key: "field_nightclubs_music",
        lbl: "Music"
      },
      {
        key: "field_nightclubs_dresscode",
        lbl: "Dress Code"
      },
      {
        key: "field_nightclubs_price",
        lbl: "Price"
      },
      {
        key: "field_nightclubs_age",
        lbl: "Age Requirements"
      },
      {
        key: "field_nightclubs_specials",
        lbl: "Specials & Promotions"
      }
    ],
    restaurants: [
      {
        key: "field_restuarants_timings",
        lbl: "Hours"
      },
      {
        key: "field_rest_dining",
        lbl: "Dining Style"
      },
      {
        key: "field_rest_dress_code",
        lbl: "Dress Code"
      },
      {
        key: "field_rest_price",
        lbl: "Prices"
      },
      {
        key: "field_rest_payment",
        lbl: "Payment Options"
      },
      {
        key: "field_rest_chef",
        lbl: "Executive Chef"
      },
      {
        key: "field_rest_accept",
        lbl: "Accepts Walk-Ins"
      },
      {
        key: "field_rest_menu",
        lbl: "Menu Link"
      },
      {
        key: "field_rest_specials",
        lbl: "Specials & Promotions"
      }
    ],
    transportation: [
      {
        key: "field_transport_timings",
        lbl: "Hours"
      },
      {
        key: "field_transport_price",
        lbl: "Prices"
      },
      {
        key: "field_transport_payment",
        lbl: "Payment Options"
      }
    ],
    fashion: [
      {
        key: "field_fashion_time",
        lbl: "Date"
      },
      {
        key: ["field_fashion_fromtime", "field_fashon_totime", "field_fashion_timezone_cust"],
        lbl: "Time",
        concat: "to"
      },
      {
        key: "field_fashion_agereq",
        lbl: "Age Requirements"
      },
      {
        key: "field_fashion_dresscode",
        lbl: "Dress Code"
      },
      {
        key: "field_fashion_drinkspecials",
        lbl: "Drink Specials"
      },
      {
        key: "field_fashion_prices",
        lbl: "Prices"
      },
      {
        key: "field_fashion_parkingoptions",
        lbl: "Parking Options"
      }
    ]
  };

  contactName = {
    event: [
      {
        key: "field_event_cname"
      }
    ],
    music: [
      {
        key: "field_music_contname"
      }
    ],
    concerts: [
      {
        key: "field_concert_cname"
      }
    ],
    bars: [
      {
        key: "field_bars_contname"
      }
    ],
    fashion_store: [
      {
        key: "field_store_contname"
      }
    ],
    fashion: [
      {
        key: "field_fashion_cname"
      }
    ],
    hotel: [
      {
        key: "field_hot_contname"
      }
    ],
    movies: [
      {
        key: "field_movies_contname"
      }
    ],
    nightclubs: [
      {
        key: "field_nightclubs_contname"
      }
    ],
    restaurants: [
      {
        key: "field_rest_contname"
      }
    ],
    transportation: [
      {
        key: "field_transport_cont_name"
      }
    ], news: [
      {
        key: "field_news_contname"
      }
    ],
    photos: [
      {
        key: "field_photos_contname"
      }
    ],
    video1: [
      {
        key: "field_video_contname"
      }
    ],
    video_live: [
      {
        key: "field_vid_contname"
      }
    ],
  };

  descimgpath = {
    nightclubs: "field_nightclubs_image",
    bars: "field_bars_image",
    restaurants: "field_restaurant_image",
    concerts: "field_concerts_image",
    event: "field_mevent_image",
    hotel: "field_upload_image_0",
    transportation: "field_transportation_image",
    fashion_store: "field_store_image",
    fashion: "field_fashion_image",
    music: "field_music_image",
    movies: "field_movie_image",
    video1: "field_video",
    video_live: "field_thumbnail",
    photos: "field_upload_photo",
    news: "field_news_image"
  };
  albumbkey = {
    nightclubs: "field_nightclubs_album",
    bars: "field_bars_album",
    restaurants: "field_rest_album",
    concerts: "field_concerts_album",
    event: "field_mevent_album",
    hotel: "field_hot_album",
    transportation: "field_transport_album",
    fashion_store: "field_store_album",
    music: "field_music_photo_album",
    fashion: "field_fashion_album",
    movies: "field_review_more_image",
    /*video1: "field_video1_album",
    photos: "field_photos_album",*/
    news: "field_news_album"
  };
  descbuttons = {
    nightclubs: 'field_nightclub_reserv',
    bars: 'field_bar_reserv',
    restaurants: 'field_restallowrsvp',
    concerts: 'field_concert_buynow',
    event: 'field_eve_buynow',
    hotel: "field_hot_res",
    transportation: "field_trans_res",
    music: "field_music_reservation",
    fashion: 'field_fashion_buynow',
  }

  getDescFormbuttons(desctypes) {
    var deschtml = "";
    if (desctypes === "bars" || desctypes === "nightclubs") {
      deschtml += "<div class='descpagebutdiv'  data-role='controlgroup'>";
      deschtml +=
        "<div class='rsvp dlinkbtn'><input type='button' value='RSVP' class='ui-btn descbut' data-bname='1' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml +=
        "<div class='bookaparty dlinkbtn'><input type='button' value='Book A Party' class='ui-btn descbut' data-bname='2' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml +=
        "<div class='reservetable dlinkbtn'><input type='button' value='Reserve A Table' class='ui-btn descbut' data-bname='3' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml += "</div>";
    } else if (
      desctypes === "event" ||
      desctypes === "fashion_store" ||
      desctypes === "concerts"
    ) {
      deschtml += "<div class='descpagebutdiv'data-role='controlgroup'>";
      deschtml +=
        "<div class='rsvp dlinkbtn'><input type='button' value='RSVP' class='ui-btn descbut' data-bname='4' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml += "</div>";
    } else if (desctypes === "restaurants") {
      deschtml += "<div class='descpagebutdiv' data-role='controlgroup'>";
      deschtml +=
        "<div class='makereservation dlinkbtn'><input type='button ' value='Make Reservation' class='ui-btn descbut' data-bname='3' onclick='unlApp.unlFormsPost(this)'></div>";
      //  deschtml += "<div class='bookaparty'><input type='button' value='Book A Party' class='ui-btn descbut' data-bname='2' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml += "</div>";
    } else if (desctypes === "music") {
      deschtml += "<div class='descpagebutdiv'>";
      deschtml +=
        "<div class='buymusic dlinkbtn'><input type='button' value='Buy Music' class='ui-btn descbut' data-bname='7' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml += "</div>";
    } else if (desctypes === "hotel") {
      deschtml += "<div class='descpagebutdiv'>";
      deschtml +=
        "<div class='makereservation dlinkbtn'><input type='button' value='Make Reservation' class='ui-btn descbut' data-bname='5' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml += "</div>";
    } else if (desctypes === "transportation") {
      deschtml += "<div class='descpagebutdiv'>";
      deschtml +=
        "<div class='makereservation dlinkbtn'><input type='button' value='Make Reservation' class='ui-btn descbut' data-bname='6' onclick='unlApp.unlFormsPost(this)'></div>";
      deschtml += "</div>";
    }
    var html = "<div class='descformscon'>" + deschtml + "</div>";
    return html;
  }
  /*
   * 1- rsvp
   * 2-book a party
   * 3-reserve a table
   * 4-rsvp with one element
   * 5- make reservation
   */
  getDescFormLink(desctypes) {
    var deschtml = "";
    if (desctypes === "bars" || desctypes === "nightclubs") {
      deschtml +=
        "<input  type='button' class='rsvp dlinkbtn' value='' data-bname='1' onclick='unlApp.unlFormsPost(this)' value='RSVP'>";
      deschtml +=
        "<input  type='button' class='bookaparty dlinkbtn' data-role='button' data-bname='2' onclick='unlApp.unlFormsPost(this)' value='Book A Party'>";
      deschtml +=
        "<input  type='button' class='reservetable dlinkbtn' data-role='button' data-bname='3' onclick='unlApp.unlFormsPost(this)' value='Reserve A Table'>";
    } else if (
      desctypes === "event" ||
      desctypes === "fashion_store" ||
      desctypes === "concerts"
    ) {
      deschtml +=
        "<input  type='button' class='rsvp dlinkbtn' data-role='button' data-bname='4' onclick='unlApp.unlFormsPost(this)' value='RSVP'>";
      deschtml +=
        "<input  type='button' class='bookaparty dlinkbtn' data-role='button' data-bname='7' onclick='unlApp.unlFormsPost(this)' value='Buy Tickets'>";
      //            deschtml += "<div class='descpagebutdiv'data-role='controlgroup'>";
      //            deschtml += "<div class='rsvp'><input type='button' value='RSVP' class='ui-btn descbut' data-bname='4' onclick='unlApp.unlFormsPost(this)'></div>";
      //            deschtml += "<div class='buytickets'><input type='button' value='Buy Tickets' class='ui-btn descbut' data-bname='7' onclick='unlApp.unlFormsPost(this)'></div>";
      //
      //
      //            deschtml += "</div>";
    } else if (desctypes === "restaurants") {
      deschtml +=
        "<input  type='button' class='bookaparty dlinkbtn' data-role='button' data-bname='3' onclick='unlApp.unlFormsPost(this)' value='Make Reservation'>";
    } else if (desctypes === "music") {
      deschtml +=
        "<input  type='button' class='buymusic dlinkbtn' data-role='button' data-bname='7' onclick='unlApp.unlFormsPost(this)' value='Buy Music'>";
    } else if (desctypes === "hotel") {
      deschtml +=
        "<input  type='button' class='bookaparty dlinkbtn'  data-role='button' data-bname='5' onclick='unlApp.unlFormsPost(this)' value='Make Reservation'>";
    } else if (desctypes === "transportation") {
      deschtml +=
        "<input  type='button' class='bookaparty dlinkbtn' data-role='button' data-bname='6' onclick='unlApp.unlFormsPost(this)' value='Make Reservation'>";
    }

    return deschtml;
  }

  getSearchURL(text: string, type, cIndex: number, city, page) {
    var url = this.viewurl + "unl_service_search.json?";
    url += "keys=" + text + "&display_id=page_2&page="+page+"&img_preset=service_mobile1&cit="+city+"&limit=10";
    if (type != 1) {  //for all
      url += "&type=" + this.getCurrentMenuType(cIndex);
    }
    return url;
  }
  updateURLParameter(url, param, paramVal) {
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL) {
      var tmpAnchor = additionalURL.split("#");
      var TheParams = tmpAnchor[0];
      TheAnchor = tmpAnchor[1];
      if (TheAnchor)
        additionalURL = TheParams;

      tempArray = additionalURL.split("&");

      for (var i = 0; i < tempArray.length; i++) {
        if (tempArray[i].split('=')[0] != param) {
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    }
    else {
      var tmpAnchor = baseURL.split("#");
      var TheParams = tmpAnchor[0];
      TheAnchor = tmpAnchor[1];

      if (TheParams)
        baseURL = TheParams;
    }
    if (TheAnchor)
      paramVal += "#" + TheAnchor;
    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  }
  getCurrentMenuType(cIndex: number) {
    if(this.menus[cIndex].ctype == "events")
      return 'event';
    else
      return this.menus[cIndex].ctype;
  }
  getWidth(parentwidth) {
    this.parentwidth = parentwidth;
  }
  setWidth() {
    return this.parentwidth;
  }

  getTermID(termID) {
    return this.basepath+'testunl/views/mw_termtree.json?args=' + termID + '&display_id=default'
  }
  getTermTitle(termID){
    this.http.get(this.basepath+'testunl/views/mw_termtree.json?args='+termID).subscribe(val => {
        return val[0].term;
    });
  }
  getMorecontent(moreDetailsArray) {
    this.moreDetailsArray = moreDetailsArray
  }
  setMorecontent() {
    return this.moreDetailsArray;
  }
  getvideodetails(vpd) {
    this.vpd = vpd;
  }
  sendvpd() {
    return this.vpd
  }
  getotherdetailtype(taxnomylist: any, currnt: any) {
    var typname = "";
    for (var i in taxnomylist) {
      var tobj = taxnomylist[i];
      if (currnt !== undefined && currnt.vid !== undefined && tobj.vid == currnt.vid) {
        typname = tobj.name;
      }
    }
    return typname;
  }
  titlee;
  getTitle(title) {
    this.titlee = title
  }
  setTitle() {
    return this.titlee
  }
  getAD(item, rmi, page) {
    var adlen = item.tabs.length;
    if (rmi === 0) {
      adlen = this.menus.length;
    }
    /*var adUrl =
      "https://papi.mynativeplatform.com/pub2/web/apiwidget.json?widget_key=vhWFtinM0GtBqXMtmXjq2f&url=https://nightlife.net/&paid_items=" + adlen + "&organic_items=" + adlen + "&organic_backfill=true&secure=true&zone&CB=";*/
    var adUrl = "./assets/json/advads.json";
    var ads = [], ads_redirect = [];
    this.http.get(adUrl).subscribe(adJson => {
      page.adJson = adJson;
       console.log(adJson,'adjson');
      for (var i = 0; i < page.adJson.items.length; i++) {
        page.adJsonContent.push(page.adJson.items[i].data.content);
        page.adJsonContent[i].impression_pixels = page.adJson.items[i].data.impression_pixels[0];
        page.adRedirect.push(page.adJson.items[i].data.action);
      }
      page.adJsonLenth = page.adJsonContent.length;
    });
    
  }

  updateVideo(vd: any) {
    this.vpd = vd;
  }
}